/*
 * Angular Selectize
 * v 1.2.3
 * https://github.com/machineboy2045/angular-selectize
 */

/*global $:Selectize */

angular
    .module('selectize', [])
    .value('selectizeConfig', {})
    .directive('selectize', [
        'selectizeConfig',
        function (selectizeConfig) {
            return {
                restrict: 'EA',
                require: '^ngModel',
                scope: {
                    ngModel: '=',
                    config: '<?',
                    options: '<?',
                    ngDisabled: '<',
                    ngRequired: '&',
                },
                link: function (scope, element, attrs, ngModelCtrl) {
                    if (!Selectize) {
                        throw new Error('Selectize JavaScript library should be loaded before using this angular module.');
                    }

                    Selectize.defaults.maxItems = null;
                    Selectize.defaults.hideSelected = true;

                    if (attrs.position) {
                        scope.posBottom = attrs.position;
                    }

                    Selectize.defaults.onDropdownOpen = function ($dropdown) {
                        $dropdown.hide().velocity('slideDown', {
                            begin: function () {
                                if (typeof scope.posBottom !== 'undefined') {
                                    $dropdown.css({ 'margin-top': '0' });
                                }
                            },
                            duration: 200,
                            easing: [0.4, 0, 0.2, 1],
                        });
                    };

                    Selectize.defaults.onDropdownClose = function ($dropdown) {
                        $dropdown.show().velocity('slideUp', {
                            complete: function () {
                                if (typeof posBottom !== 'undefined') {
                                    $dropdown.css({ 'margin-top': '' });
                                }
                            },
                            duration: 200,
                            easing: [0.4, 0, 0.2, 1],
                        });
                    };

                    var selectize,
                        config = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

                    // override to support checking empty arrays/objects
                    ngModelCtrl.$isEmpty = function (val) {
                        return !val || (_.isObject(val) && _.isEmpty(val));
                    };

                    ngModelCtrl.$parsers.push(function (value) {
                        if (1 < config.maxItems && !angular.isArray(value)) {
                            value = value.split(',');
                        }
                        return value;
                    });

                    function createItem(input) {
                        var item = input;

                        if (typeof input === 'object') {
                            item = {};
                            item[config.labelField] = input[config.labelField];
                            item[config.valueField] = input[config.valueField];
                        }

                        return item;
                    }

                    function toggle(disabled) {
                        disabled ? selectize.disable() : selectize.enable();
                    }

                    function validate() {
                        var isInvalid = (scope.ngRequired() || attrs.required || config.required) && ngModelCtrl.$isEmpty(scope.ngModel);
                        ngModelCtrl.$setValidity('required', !isInvalid);
                    }

                    function generateOptions(data) {
                        if (!data) {
                            return [];
                        }

                        data = angular.isArray(data) ? data : [data];

                        return $.map(_.sortBy(data, 'order'), function (opt) {
                            return createItem(opt);
                        });
                    }

                    function updateSelectize() {
                        validate();

                        selectize.$control.toggleClass('ng-valid', ngModelCtrl.$valid);
                        selectize.$control.toggleClass('ng-invalid', ngModelCtrl.$invalid);
                        selectize.$control.toggleClass('ng-dirty', ngModelCtrl.$dirty);
                        selectize.$control.toggleClass('ng-pristine', ngModelCtrl.$pristine);

                        var value = selectize.items.slice();
                        if (config.maxItems === 1) {
                            value = value[0];
                        }

                        if (!angular.equals(value, scope.ngModel)) {
                            if (!ngModelCtrl.$isEmpty(scope.ngModel)) {
                                selectize.addOption(generateOptions(scope.ngModel));
                                selectize.setValue(scope.ngModel);
                            } else {
                                selectize.clear(true);
                            }
                        }
                    }

                    var onChange = config.onChange,
                        onOptionAdd = config.onOptionAdd;

                    config.onChange = function () {
                        var args = arguments;
                        scope.$evalAsync(function () {
                            var value = selectize.items.slice();
                            if (config.maxItems === 1) {
                                value = value[0];
                            }
                            if (!angular.equals(value, scope.ngModel)) {
                                ngModelCtrl.$setViewValue(value);
                                if (onChange) {
                                    onChange.apply(this, args);
                                }
                            }
                        });
                    };

                    config.onOptionAdd = function (value, data) {
                        if (scope.options.indexOf(data) === -1) scope.options.push(data);

                        if (onOptionAdd) {
                            onOptionAdd.apply(this, arguments);
                        }
                    };

                    // ngModel (ie selected items) is included in this because if no options are specified, we
                    // need to create the corresponding options for the items to be visible
                    //scope.options = generateOptions((scope.options || config.options || scope.ngModel).slice());

                    scope.generatedOptions = generateOptions((scope.options || config.options || scope.ngModel).slice());
                    scope.options = [];
                    scope.generatedOptions.forEach(function (item) {
                        scope.options.push(item);
                    });

                    var angularCallback = config.onInitialize;

                    config.onInitialize = function () {
                        selectize = element[0].selectize;
                        //selectize.addOption(scope.options);
                        selectize.addOption(scope.generatedOptions);
                        selectize.setValue(scope.ngModel);

                        //provides a way to access the selectize element from an
                        if (angularCallback) {
                            angularCallback(selectize);
                        }

                        scope.$watch(
                            'options',
                            function () {
                                scope.generatedOptions = generateOptions((scope.options || config.options || scope.ngModel).slice());
                                scope.options = [];
                                scope.generatedOptions.forEach(function (item) {
                                    scope.options.push(item);
                                });
                                selectize.clearOptions();
                                selectize.addOption(scope.generatedOptions);
                                selectize.setValue(scope.ngModel);
                            },
                            true
                        );

                        scope.$watchCollection('ngModel', updateSelectize);
                        scope.$watch('ngDisabled', toggle);
                    };

                    element.after('<div class="selectize_fix"></div>');

                    element.selectize(config);

                    element.on('$destroy', function () {
                        if (selectize) {
                            selectize.destroy();
                            element = null;
                        }
                    });
                },
            };
        },
    ]);
